// src/components/PermissionDeniedToast.jsx
//
// almada §9.3 — global Arabic snackbar for any Firestore PERMISSION_DENIED
// caught by the app. Listens for the `bayan:permission-denied` CustomEvent
// emitted by `src/utils/permissionDenied.js` and renders a tight MUI
// Snackbar at the bottom of the viewport.
//
// The detail line under the headline shows path / role / tenantId so a
// moudir can screenshot the toast and forward it to support without us
// having to reproduce.

import React, { useEffect, useState } from 'react';
import { Snackbar, Alert, Typography, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function PermissionDeniedToast() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [detail, setDetail] = useState(null);

  useEffect(() => {
    const handler = (evt) => {
      const next = evt?.detail || null;
      setDetail(next);
      setOpen(true);
    };
    window.addEventListener('bayan:permission-denied', handler);
    return () => window.removeEventListener('bayan:permission-denied', handler);
  }, []);

  if (!open) return null;
  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={() => setOpen(false)}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert
        severity="warning"
        variant="filled"
        onClose={() => setOpen(false)}
        sx={{ maxWidth: 480, direction: 'rtl' }}
      >
        <Box sx={{ fontWeight: 700, mb: 0.5 }}>
          {t('errors.permissionDenied')}
        </Box>
        {detail && (detail.path || detail.role || detail.tenantId) && (
          <Typography variant="caption" sx={{ display: 'block', opacity: 0.85 }}>
            {[detail.path, detail.role, detail.tenantId]
              .filter(Boolean)
              .join(' · ')}
          </Typography>
        )}
      </Alert>
    </Snackbar>
  );
}
